import { Vue } from 'vue-property-decorator';
import { annotateSession } from '@/helpers/DynamicMessages';
import { getQuantityParam, getQueryParam } from '@/helpers/QueryStringParameters';
import { isTrueish } from '@/helpers/StringHelpers';
import { TixTime } from '@/TixTime/TixTime';
import QueryParameterError, { isQueryParameterError } from '@/errors/QueryParameterError';
export default class ReserveBase extends Vue {
    initializationWarning = null;
    initializationError = null;
    get availableTicketTypes() {
        return this.availableTGs.reduce((tickeTypes, group) => {
            return [...tickeTypes, ...group.types];
        }, []);
    }
    selectDate(date) {
        // Check if the date of the session is still available before selecting it
        if (this.availableDates.includes(date.format('DATE'))) {
            this.selectedDate = date;
            return '';
        }
        return this.$t('reserve.unavailableOnDate');
    }
    selectDateBySession(session, venue) {
        const date = new TixTime(session.start_datetime, venue.timezone);
        return this.selectDate(date);
    }
    selectSessionByID(sessionID) {
        const session = this.sessions?.find((s) => s.id === sessionID);
        if (session) {
            this.selectedSession = annotateSession(session, this.event);
            return '';
        }
        return this.$t('reserve.sessionUnavailable');
    }
    selectQuantitiesByQueryParams() {
        const quantityParamValue = getQuantityParam()?.value;
        if (!quantityParamValue) {
            return '';
        }
        const tempQuantities = {};
        for (const [ticketType, num] of Object.entries(quantityParamValue)) {
            const types = this.availableTicketTypes.filter((t) => {
                // Ticket type can be id or name
                return t.id === ticketType || t.name === ticketType;
            });
            for (const type of types) {
                tempQuantities[type.id] = { quantity: num };
            }
        }
        if (Object.keys(tempQuantities).length === 0) {
            return this.$tc('reserve.ticketTypesNotFound', Object.keys(quantityParamValue).length);
        }
        this.selectedQuantities = { ...this.selectedQuantities, ...tempQuantities };
        return '';
    }
    get normalizedReserveParam() {
        const reserveParam = getQueryParam('reserve')?.value ?? '';
        let reserve = 'false';
        if (['warn', 'strict'].includes(reserveParam)) {
            reserve = reserveParam;
        }
        else if (isTrueish(reserveParam)) {
            reserve = 'true';
        }
        return reserve;
    }
    handleQueryParamError(error) {
        if (error) {
            throw new QueryParameterError(error);
        }
    }
    handleLoadParamError(e, reserve) {
        if (!isQueryParameterError(e)) {
            throw e;
        }
        else if (reserve === 'warn') {
            this.initializationWarning = e.message;
        }
        else if (reserve === 'strict') {
            this.initializationError = this.$t('reserve.unavailable');
        }
    }
}
